import { QuranFont } from '../QuranReader';

export default QuranFont;
